import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-dialoge',
  templateUrl: './nav-dialoge.component.html',
  styleUrls: ['./nav-dialoge.component.css']
})
export class NavDialogeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  selectedLanguage(language:string){
    
  }
}
